export default {
    
    SET_USER_DATA(state, payload) {
        state.user = payload
    },
}